import { createFileRoute } from '@tanstack/react-router'
import { FreeSWITCHProfilesPage } from '@/features/freeswitch'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/freeswitch/profiles/')(
  {
    component: FreeSWITCHProfilesPage,
    beforeLoad: requireRole(['admin']),
  },
)
